__turbopack_context__.v({
  "button": "WSqXla_button",
  "image": "WSqXla_image",
  "image-is-background": "WSqXla_image-is-background",
  "playback-control": "WSqXla_playback-control",
  "video": "WSqXla_video",
  "video-is-background": "WSqXla_video-is-background",
  "video-is-visible": "WSqXla_video-is-visible",
  "with-playback-control": "WSqXla_with-playback-control",
});
